import { defiCategoryType } from '~/types/defi.type'

export const TOOLTIP = {
  analytics: {
    avgDAA: 'Avg.DAA(30D) is Daily Average Active Addresses (30D), representing the daily average number of active addresses, calculated by dividing the total number of active addresses over a 30-day period by 30.',
    avgDailyTx: 'Avg. Daily Tx(30D) is the Daily Average Transaction (30D), representing the daily average transaction count, calculated by dividing the total number of transactions over a 30-day period by 30.'
  },
  ecosystem: {
    stickness: 'Stickness is the number of daily active addresses divided by the number of monthly active addresses, reflecting the frequency and consistency of users\' use of the service. \n' +
      'A high stickness value indicates that users are consistently engaged with the service, which is an important indicator of service stability in the blockchain industry.',
  },
  content: {
    intelligence: 'The date when the announced event is actually applied or scheduled to be applied.'
  }
}

export const DEFI_CATEGORY_TOOLTIP: Record<Partial<defiCategoryType>, string> = {
  [defiCategoryType.LIQUID_STAKING]: 'This protocol deposits into another protocol or is under Liquid Staking' +
  ' category, so it is subtracted from total TVL.',
  [defiCategoryType.YIELD]: 'This protocol deposits into another protocol or is under Liquid Staking category, so it' +
' is subtracted from total TVL.',
  [defiCategoryType.RWA]: 'RWA protocols are not included in chain TVL.',
}

export const DEFI_CATEGORY_PARENT_TOOLTIP: Record<Partial<defiCategoryType>, string[]> = {
  [defiCategoryType.LIQUID_STAKING]: [
    'Some subprotocols are excluded from chain TVL.\n',
    'There\'s some internal doublecounting that is excluded from parent TVL, so sum won\'t match.'
  ]
}